import React, { useState, useEffect } from "react";
import {
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableContainer,
  CardContent,
  Card,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { images } from "../../config/images";
import { useSelector } from "react-redux";
import {
  getOutFeedVisualInspectionDefectDetails,
  getReport,
} from "../Reports & Approvals/services";
import { param } from "jquery";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getBatchId, getOutFeedDefectsList } from "../ProductionLine/services";

const ReportVisualInspection = ({ closeModal, props }) => {
  const [batchType, setBatchType] = useState();
  const [reportStatus, setReportStatus] = useState([]);
  const [reportPayload, setReportPayload] = useState([]);
  const [Report_Payload_Data, setReport_Payload_Data] = useState();
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isLoading, setLoading] = useState(false);
  const [sendingID, setSendingId] = useState(false);
  const [approveStatus, setApproveStatus] = useState("");
  const [rejectedButton, setRejectedButton] = useState(false);
  const [sendingmsg, setSendingMsg] = useState(false);
  const [status1, setStatus1] = useState(null);
  const [comment, setComment] = useState("");
  const [checkUidData, setCheckUidData] = useState(false);
  const [defectListData, setDefectListData] = useState([]);

  const initiallValue = {
    Date: "",
    B_No: "",
    UID: "",
    Test_date: "",
    Test_Time: "",
    Shift: "",
    Lot_No: "",
    Class: "",
    Size: "",
    Thickness: "",
    Print_Result: "",
    RorL: "",
    Approve_status: "",
  };
  const { userPermission } = useSelector((state) => state.userState);
  const location = useLocation();
  const params = useParams();
  const batchId = params.id;
  const [searchText, setSearchText] = useState(initiallValue);
  const [outFeedData, setOutFeedData] = useState([]);

  useEffect(() => {
    getBatchData();
  }, []);

  const getBatchData = async () => {
    try {
      const resp = await getBatchId(batchId);

      if (resp.status == 200 || resp.status == 201) {
        setBatchType(resp.data);
      }
    } catch (error) {
      setLoading(false);
      console.log("handleSubmit", error);
    }
  };

  useEffect(() => {
    handleApprovedStatus();
  }, []);

  const handleApprovedStatus = async (row, status) => {
    console.log("statusstatusstatus", status);
    setLoading(true);
    const params = {
      batch_id: batchId,
    };
    setBatchType(row);
    try {
      const resp = await getReport(params);
      setLoading(false);
      if (resp.status == 200 || resp.status == 201) {
        setReportStatus(resp.data.payload.payload);
        setReportPayload({
          Accepted_Qty: resp.data.payload.accepted,
          Rejected_Qty: resp.data.payload.rejected,
        });
        setReport_Payload_Data(resp.data.payload.payload);
        setApproveStatus(status);
      }
    } catch (error) {
      setLoading(false);
      console.log("handleSubmit", error);
    }

    // setGlovesTable(false);
  };

  const tableHeadStyle = {
    position: "sticky",
    top: "-7px",
    zIndex: isLoading ? "auto" : 9,
  };

  const handleToastMsg = () => {
    toast.error("You don't have access", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleCheckUidData = (finddata) => {
    setCheckUidData(finddata);
  };
  useEffect(() => {
    handleDefectList();
  }, []);

  const handleDefectList = async () => {
    try {
      const resp = await getOutFeedDefectsList();
      if (resp.status == 200 || resp.status == 201) {
        setDefectListData(resp.data.payload);
      }
    } catch (error) {
      setDefectListData([]);
    }
  };

  useEffect(() => {
    handleVisualInspectionDetails();
  }, []);

  const handleVisualInspectionDetails = async () => {
    try {
      const resp = await getOutFeedVisualInspectionDefectDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setOutFeedData(resp.data.payload);
      }
    } catch (error) {
      setOutFeedData([]);
      console.log("handleSubmit", error);
    }
  };

  const navigate = useNavigate();


  return (
    <>
      <div className="min-h-screen bg-[#f5f3ff] p-8 dashboard-wrapper page-wraper">
        <div className="page-header">
          <div
            onClick={() => navigate("/reports")}
            className="page-back-btn"
            style={{ cursor: "pointer" }}
          >
            <ArrowBackIcon />
            <span>Out Feed Visual Inspection</span>
          </div>
        </div>

        <div className="mt-5">
          <div className="header-approval-data electricTest-data">
            <Grid container>
              <Grid
                lg={3}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Mfg Date:
                      </TableCell>
                      <TableCell>
                        {dayjs(outFeedData ? outFeedData.created_at : "").format(
                          "YYYY-MM-DD"
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Batch No:
                      </TableCell>
                      <TableCell>
                        {outFeedData ? outFeedData.batch_type : ""}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={2}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Lot No:</TableCell>
                      <TableCell>
                        {outFeedData ? outFeedData.lot_no : ""}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Thickness:
                      </TableCell>
                      <TableCell>
                        {outFeedData
                          ? outFeedData.thickness
                          : "-"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={2}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Class:</TableCell>
                      <TableCell>
                        {outFeedData ? outFeedData.class_name : ""}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Size:</TableCell>
                      <TableCell>
                        {outFeedData ? outFeedData.size_name : ""}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={2}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Accepted Qty:
                      </TableCell>
                      <TableCell>{outFeedData.accepted_qty}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Rejected Qty:
                      </TableCell>
                      <TableCell>{outFeedData.rejected_qty}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid
                lg={3}
                md={6}
                sm={6}
                xs={12}
                sx={{ P: 0 }}
                className="single-data-item"
              >
                <Table className="no-border-table transparent-table common-table">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>
                        Operator Name:
                      </TableCell>
                      <TableCell>
                        {outFeedData
                          ? outFeedData.operator
                            ? outFeedData.operator
                            : "-"
                          : ""}
                      </TableCell>
                    </TableRow>
                    
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </div>

          <div className="table-responsive">
            <TableContainer
              style={{
                border: "1px solid #a9b0bd",
                maxHeight: "60vh",
                background: "#ffff",
              }}
              className="reportTable"
            >
              <Table
                aria-label="reports"
                className="statusflow"
                style={{ width: "fit-content" }}
              >
                <TableHead style={tableHeadStyle}>
                  <TableRow>
                    <TableCell className="statusflow-defects">
                      <div className="p-3">Defects</div>
                    </TableCell>
                    {outFeedData?.ofvi_sub_parts &&
                    Array.isArray(outFeedData.ofvi_sub_parts)
                      ? outFeedData.ofvi_sub_parts.map((subPart) => {
                          return (
                            <TableCell
                              className={
                                subPart.fail_ofvi !== null
                                  ? "defects-head"
                                  : ""
                              }
                            >
                              <div className="defects">
                                Tray No: {subPart.sub_part_number}
                                <br />
                                Date:{" "}
                                {dayjs(outFeedData.created_at).format(
                                  "YYYY-MM-DD"
                                )}
                                <br />
                                Shift: {outFeedData.shift_name}
                              </div>
                            </TableCell>
                          );
                        })
                      : ""}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {defectListData.map((defect, index) => (
                    <TableRow key={defect.id} className="historyTitle">
                      <TableCell className="statusflow-defects">
                        <b className="font-bold">
                          {String(index + 1).padStart(2, "0")}
                        </b>{" "}
                        {defect.name}
                      </TableCell>
                      {outFeedData?.ofvi_sub_parts?.length &&
                      Array.isArray(outFeedData.ofvi_sub_parts)
                        ? outFeedData.ofvi_sub_parts.map((status1) => {
                            const defectStatus =
                              status1.fail_ofvi &&
                              status1.fail_ofvi.defects &&
                              status1.fail_ofvi.defects.some(
                                (e) => e.name === defect.name
                              );

                            return (
                              <TableCell key={status1.id}>
                                <div
                                  className={`status-icon ${
                                    defectStatus ? "falied" : "pass"
                                  }`}
                                >
                                  {defectStatus ? "F" : "P"}
                                </div>
                              </TableCell>
                            );
                          })
                        : ""}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {isLoading && <Loader />}
          </div>

          <div className="d-flex justify-content-end aborted">
            <p style={{ margin: 0, marginBottom: 0 }}>
              Powered by <b>Hikar&#174;Technomation</b> Private Limited &#169;
              All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportVisualInspection;
